module.exports = __webpack_public_path__ + "img/icon_main_order.9d6d94ef.svg";